// extracted by mini-css-extract-plugin
export default {"game":"GameFrame_game__PWQj5","buttons":"GameFrame_buttons__P5z6u"};